/**
 * Open Stripe Checkout / Portal in a new tab without navigating the current page.
 * Call {@link prepareBillingTab} synchronously on click, then {@link navigateBillingTab} after the API returns.
 */

export function prepareBillingTab(): Window | null {
  const tab = window.open("about:blank", "_blank");
  if (tab) {
    tab.opener = null;
  }
  return tab;
}

export function navigateBillingTab(tab: Window | null, url: string): boolean {
  if (!tab || tab.closed) {
    return false;
  }
  try {
    tab.location.href = url;
    return true;
  } catch {
    closeBillingTab(tab);
    return false;
  }
}

export function closeBillingTab(tab: Window | null): void {
  if (!tab || tab.closed) {
    return;
  }
  try {
    tab.close();
  } catch {
    /* ignore */
  }
}

/** User-opt-in fallback when popups are blocked. */
export function openBillingUrlInSameTab(url: string): void {
  window.location.assign(url);
}
